<script setup lang="ts">
import { computed } from 'vue';
import { DropdownMenuItem } from 'reka-ui';
import Icon from '../icon/icon.vue';
import { IconSize } from '../icon/icon.constants';
import { useLink } from '../../composables/use-link';
import type { MenuItem } from './menu.types';
import {
  menuItemBaseClass,
  menuItemDestructiveClass,
  menuItemIconClass,
  menuItemRegularClass,
} from './menu.styles';

type Props = {
  item: MenuItem;
};

const props = defineProps<Props>();

const linkComponent = useLink();

const tag = computed(() => {
  if (props.item.to !== undefined) return linkComponent;
  if (props.item.href !== undefined) return 'a';

  return 'div';
});

const linkProps = computed(() => {
  if (props.item.to !== undefined) return { to: props.item.to };
  if (props.item.href !== undefined) return { href: props.item.href };

  return {};
});
</script>

<template>
  <DropdownMenuItem
    :as="tag"
    v-bind="linkProps"
    :disabled="props.item.disabled"
    :text-value="props.item.label"
    :class="[
      menuItemBaseClass,
      props.item.destructive ? menuItemDestructiveClass : menuItemRegularClass,
    ]"
    @select="props.item.onSelect?.($event)"
  >
    <Icon
      v-if="props.item.leftIconName"
      :name="props.item.leftIconName"
      :size="IconSize.MD"
      :class="props.item.destructive ? 'shrink-0' : menuItemIconClass"
    />
    <span class="min-w-0 flex-1">
      <slot>
        <span class="block wrap-break-word">{{ props.item.label }}</span>
      </slot>
    </span>
  </DropdownMenuItem>
</template>
